import type { ShipmentColumn } from '../../types/column-types'
import { onCellStandard, renderShipment } from '../../helpers/helpers'
import Shipment from '../../../../types/api/shipment'
import ShipmentWindingSchemesPopover from '../../components/cells/form-items/shipment-winding-schemes-popover'
import { windingsDisplay } from '../../../../types/api/shipment'

// const schemeLetter = (v: string | undefined) => (v ? String(v).toUpperCase() : '—')

export const windingSchemesColumn: ShipmentColumn = {
    key: 'windingSchemes',
    dataIndex: 'windingSchemeFace',
    title: 'Схема намотки',
    width: 72,
    editable: true,
    fieldDescriptors: [
        {
            name: 'windingSchemeFace',
            getValue: (record: Shipment) => record.windingSchemeFace,
        },
        {
            name: 'windingSchemeTurn',
            getValue: (record: Shipment) => record.windingSchemeTurn,
        },
    ],
    FormItem: <ShipmentWindingSchemesPopover />,
    onCell: onCellStandard,
    render: renderShipment(
        s => `${windingsDisplay(s.windingSchemeFace)} / ${windingsDisplay(s.windingSchemeTurn)}`
    ),
}
